module.exports = __webpack_public_path__ + "img/download.6dd93caf.webp";